import React, { useState } from 'react';
import { Container, Card, Row, Col } from 'react-bootstrap';

export default function Events(){
  const [openIndex, setOpenIndex] = useState(null);
  const events = [
    
    {
      id: 1,      
      title: 'Fellowship Lunch',
      time: 'Nov 29, 2026',
      description: 'Join us for fellowship and community meal after service',
      icon: '/icons/fellowship.png'      
    },
   {
      id: 2,      
      title: 'Christmas Musical',
      time: 'Dec 12, 2026',
      description: 'Join us for a festive Christmas musical performance. Click on the link to register.',
      icon: '/icons/christmasMusic.png',
      link: ''      
    }
  ];

  return (
    <>
      <Container className="px-1" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <div style={{ color: '#1a3a44', borderRadius: '0', padding: '1.5rem 2rem 2rem', zIndex: 3, fontFamily: "'Nyoetes', 'Sora', 'Space Grotesk', 'Poppins', 'Segoe UI', sans-serif" }}>
          <div className="text-center mb-4">
            <h2 className="fw-bold mb-3" style={{ fontSize: '3.425rem', color: '#c53607f5' }}>Upcoming Events</h2>
          </div>
          <Row className="g-2 justify-content-center">
            {events.map((event, index) => (
              <Col key={index} xs={12} sm={6} lg={3}>
                <Card className="h-100" style={{ background: 'rgba(255,255,255,0.15)', backdropFilter: 'blur(10px)', display: 'flex', flexDirection: 'column', border: '4px solid rgba(255,255,255,0.2)', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', transition: 'transform 0.2s, box-shadow 0.2s', paddingBottom: '10px' }} onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.2)'; setOpenIndex(index); }} onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)'; setOpenIndex(null); }}>
                  <Card.Img src={event.icon} variant="top" style={{ height: '140px', objectFit: 'contain', padding: '12px 12px 0' }} />
                  <Card.Body className="text-center" style={{ flex: '1', display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: '0.5rem', color: '#c53607f5' }}>
                    <Card.Title className="h6 fw-bold mb-2" style={{ fontSize: '1.625rem' }}>{event.title}</Card.Title>
                    <Card.Text style={{ fontSize: '1.525rem', lineHeight: '1.4' }}>{event.time}</Card.Text>
                    {openIndex === index && (
                      <Card.Text style={{ fontSize: '1.525rem', lineHeight: '1.4', marginTop: '8px' }}>{event.description}</Card.Text>
                    )}
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      </Container>
    </>
  );
}
